
import {  Button, Col, Divider, Input, Row, Space, Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectColumns, selectDataSource, selectloadStatus, selectTotal } from "./userSlice";
import { useEffect, useState } from "react";
import { getUser } from "./userThunk";
import { CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import RoutePath from "../../app/routing/routes.path";
import { FilterDropdown } from "../../app/components/generic";





export default function User() {
    const dispatch = useAppDispatch();
    
    const [columns, setColumns] = useState([]);
    
    const loadStatus = useAppSelector(selectloadStatus)
    const dataSource = useAppSelector(selectDataSource);
    const columnsList = useAppSelector(selectColumns);
    const total = useAppSelector(selectTotal);

    const navigate = useNavigate();
    let [query, setQueryParams] = useSearchParams();

    useEffect(()=> {
        dispatch(getUser({query}));
    },[query]);
    

    useEffect(()=> {
        setColumns(columnsList.map((col:any)=>{
            const c = {...col}
            if (['name', 'active'].includes(c.key)) {
                c.sorter = true;
            }
            if (['name', 'email', 'mobile'].includes(c.key)) {
                let params = new URLSearchParams(query.toString());
                let filter = JSON.parse(params.get('filter') || '{}');
                let value = filter[c.key] ? filter[c.key]['$regex'] : '';
                c.filterDropdown = <FilterDropdown
                    fkey={c.key}
                    // value={value}
                    // onSearch={(value: any) => {
                    //     let params = new URLSearchParams(query.toString());
                    //     let filter = JSON.parse(params.get('filter') || '{}');
                    //     if (value){
                    //         filter[c.key] = {$regex: value, $options: 'i' };
                    //     }
                    //     else {
                    //         delete filter[c.key];
                    //     }
                    //     params.set('filter', JSON.stringify(filter));
                    //     params.set('page', '1');
                    //     setQueryParams(params);
                    // }}
                />;
            }
            if (c.key == 'active') {
                c.title = "Active";
                c.render = (icon: any) => {
                    return icon ? <CheckOutlined style={{color: 'green'}}/> : <CloseOutlined style={{color: 'red'}}/>;
                }
            }
            return c;
        }))
    },[columnsList]);

    const onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
        console.log('params', pagination, filters, sorter, extra);
        let params = new URLSearchParams(query.toString());
        params.set('page', pagination.current);
        params.set('pageSize', pagination.pageSize);
        if (sorter && sorter.field) {
            params.set('sort', JSON.stringify({[sorter.field]: sorter.order}));
        }
        if (filters) {
            params.set('filter', JSON.stringify(filters));
        }
        setQueryParams(params);
    };
    
    return (<>
        <Row justify="space-between">
            <Col span={18}>
                
            </Col>
            <Col span={6}>
                <Space.Compact style={{float: 'right'}}>
                    <Link to={RoutePath.add}>
                        <Button type="primary" icon={<PlusOutlined />} >
                            Add
                        </Button>
                    </Link>
                </Space.Compact>
            </Col>
        </Row>
        <Divider/>
        <Table showSorterTooltip sticky
            dataSource={dataSource}
            columns={columns}
            loading={loadStatus === 'loading'}
            onChange={onChange}
            pagination={
                {
                    position: ['bottomCenter'],
                    total:total,
                    pageSizeOptions: ['10','20','50'], 
                    showSizeChanger: true, 
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
                }
            }
            onRow={(record) => {
                return {
                    onClick: (event) => {
                        navigate(`${RoutePath.user}/view/${record._id}`)
                    }
                };
            }} />
    </>
    )
}

